<template>
  <div class="mini-kasko-city-field form-group">
    <el-select
      v-model="selectedCity"
      :disabled="disabled"
      :class="{ 'mini-kasko-city-field--invalid': Boolean(error) }"
      placeholder="Оберіть місто"
      popper-class="mini-kasko-city-field__dropdown"
      filterable
      remote
      :remote-method="handleSearch"
      :loading="isLoading"
    >
      <el-option v-for="item in cityOptions"
                 :key="item.id"
                 :label="item.name_full_name_ua"
                 :value="item.id">
      </el-option>
    </el-select>
    <small v-if="error" class="mini-kasko-order__field-error">{{ error }}</small>
  </div>
</template>

<script>
export default {
  name: 'MiniKaskoCityField',
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: Number,
      default: '',
    },
    selectedLabel: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      cityOptions: [ { 'id': 1,'name': 'Київ','name_full_name_ua': 'м. Київ, Україна', 'zone':1 },
        { 'id': 9,'name': 'Дніпро','name_full_name_ua': 'м. Дніпро, Дніпропетровська  обл., Україна', 'zone':2 },
        { 'id': 11,'name': 'Львів','name_full_name_ua': 'м. Львів, Львівська  обл., Україна', 'zone':1 },
        { 'id': 13,'name': 'Одеса','name_full_name_ua': 'м. Одеса, Одеська  обл., Україна', 'zone':2 },
        { 'id': 14,'name': 'Харків','name_full_name_ua': 'м. Харків, Харківська  обл., Україна', 'zone':2 },
        { 'id': 16,'name': 'Запоріжжя','name_full_name_ua': 'м. Запоріжжя, Запорізька  обл., Україна', 'zone':3 },
        { 'id': 17,'name': 'Кривий Ріг','name_full_name_ua': 'м. Кривий Ріг, Дніпропетровська  обл., Україна', 'zone':3 },
        { 'id': 21,'name': 'Вінниця','name_full_name_ua': 'м. Вінниця, Вінницька  обл., Україна', 'zone':4 },
        { 'id': 36,'name': 'Маріуполь','name_full_name_ua': 'м. Маріуполь, Донецька  обл., Україна', 'zone':4 },
        { 'id': 41,'name': 'Полтава','name_full_name_ua': 'м. Полтава, Полтавська  обл., Україна', 'zone':4 }],
      isLoading: false,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.ensureSelectedOption(value, this.selectedLabel);
      },
    },
    selectedLabel: {
      immediate: true,
      handler(label) {
        this.ensureSelectedOption(this.value, label);
      },
    },
  },
  computed: {
    selectedCity: {
      get() {
        return this.value;
      },
      set(value) {
        const selectedOption = this.cityOptions.find((item) => Number(item.id) === Number(value)) || null;

        this.$emit('input', value)
        this.$emit('change', selectedOption);
      }
    }
  },
  methods: {
    normalizeLabel(value) {
      return typeof value === 'string' ? value.trim() : '';
    },
    ensureOptionExists(city) {
      if (!city || !city.id) {
        return;
      }

      if (!this.cityOptions.some((item) => item.id === city.id)) {
        this.cityOptions = [city].concat(this.cityOptions);
      }
    },
    ensureSelectedOption(id, label) {
      if (!id || !label) {
        return;
      }

      this.ensureOptionExists({
        id,
        name_full_name_ua: label,
      });
    },
    async handleSearch(query) {
      const normalizedQuery = this.normalizeLabel(query);

      if (normalizedQuery.length < 2) {
        return;
      }

      this.isLoading = true;

      try {
        const { data } = await axios.get('/api/directories/cities/find', {
          params: {
            city: normalizedQuery,
          },
        });
        this.cityOptions = Array.isArray(data?.data) ? data.data : [];

        if (this.selectedCity) {
          this.ensureSelectedOption(this.selectedCity, this.selectedLabel);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    focus() {
      this.$nextTick(() => {
        const input = this.$el.querySelector('.el-input__inner');

        if (this.$el && typeof this.$el.scrollIntoView === 'function') {
          this.$el.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        }

        if (input && typeof input.focus === 'function') {
          input.focus();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.mini-kasko-city-field {
  width: 100%;

  .mini-kasko-order__field-error {
    color: #dc2626;
    font-size: 12px;
    line-height: 16px;
  }

  ::v-deep .el-select {
    width: 100%;
  }

  ::v-deep .el-input__inner {
    width: 100%;
    min-height: 44px;
    height: 44px;
    padding: 10px 36px 10px 12px;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    background: #fff;
    color: inherit;
    font: inherit;
    box-shadow: none;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }

  ::v-deep .el-input__inner::placeholder {
    font: inherit;
    color: #71717a;
  }

  ::v-deep .el-input__inner,
  ::v-deep .el-input__icon,
  ::v-deep .el-select__caret {
    line-height: inherit;
  }

  ::v-deep .el-input,
  ::v-deep .el-select,
  ::v-deep .el-select__caret,
  ::v-deep .el-input__suffix,
  ::v-deep .el-input__suffix-inner {
    color: inherit;
    font: inherit;
  }

  ::v-deep .el-input.is-focus .el-input__inner,
  ::v-deep .el-select .el-input__inner:focus {
    border-color: #fb923c;
    box-shadow: 0 0 0 3px rgba(251, 146, 60, 0.15);
  }

  ::v-deep .el-input.is-disabled .el-input__inner {
    background: #f8fafc;
    color: #52525b;
    cursor: default;
  }

  ::v-deep .el-input__suffix {
    display: flex;
    align-items: center;
    right: 12px;
  }

  ::v-deep .el-input__suffix-inner {
    display: flex;
    align-items: center;
  }

  ::v-deep .el-select__caret {
    color: #71717a;
    font-size: 14px;
  }

  &--invalid {
    ::v-deep .el-input__inner {
      border-color: #ef4444;
    }

    ::v-deep .el-input.is-focus .el-input__inner,
    ::v-deep .el-select .el-input__inner:focus {
      border-color: #ef4444;
      box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.12);
    }
  }
}
</style>

<style lang="scss">
.mini-kasko-city-field__dropdown {
  .el-select-dropdown__item,
  .el-select-dropdown__empty {
    color: inherit;
    font: inherit;
    align-content: center;
  }
}
</style>
